"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGqlCardToOldCard = void 0;
const video_cards_1 = require("@wix/wix-vod-constants/video-cards");
const video_cards_2 = require("../../mappers/video-cards");
function mapGqlCardToOldCard(card, { clientId }) {
    return {
        actionId: card.id,
        actionItemId: card.targetVideoId,
        actionListId: card.targetChannelId,
        buttonLabel: card.buttonText,
        type: video_cards_2.cardTypeMapper.toVod(card.type),
        network: card.targetExternalType
            ? video_cards_2.networkMapper.toVod(card.targetExternalType)
            : null,
        text: card.title,
        thumbnailUrl: card.thumbnailUrl,
        url: card.targetExternalUrl,
        updatedTimestamp: card.customOrder,
        clientId,
        orientation: video_cards_1.VIDEO_CARDS_ORIENTATIONS.HORIZONTAL,
        position: video_cards_2.positionMapper.toVod(card.position),
        appearance: {
            start: card.showAt,
            duration: card.hideAt - card.showAt,
        },
    };
}
exports.mapGqlCardToOldCard = mapGqlCardToOldCard;
//# sourceMappingURL=mappers.js.map